import { UseFormReturn } from 'react-hook-form';
import { 
  ExtendedBusinessDetails, 
  BusinessBasicDetails, 
  ShiftAssignmentSettings,
  TimeTrackingSettings,
  createBusinessDefaults, 
  createShiftDefaults,
  createTimeTrackingDefaults,
  createCompleteFormDefaults 
} from './business-form-defaults';

/**
 * Resets business basic details form to original values
 */
export const resetBusinessForm = (
  form: UseFormReturn<BusinessBasicDetails>, 
  businessDetails: ExtendedBusinessDetails
) => {
  form.reset(createBusinessDefaults(businessDetails));
};

/**
 * Resets shift assignment settings form to original values
 */
export const resetShiftSettingsForm = (
  form: UseFormReturn<ShiftAssignmentSettings>, 
  businessDetails: ExtendedBusinessDetails
) => {
  form.reset(createShiftDefaults(businessDetails));
};

/**
 * Resets time tracking settings form to original values
 */
export const resetTimeTrackingSettingsForm = (
  form: UseFormReturn<TimeTrackingSettings>, 
  businessDetails: ExtendedBusinessDetails
) => {
  form.reset(createTimeTrackingDefaults(businessDetails));
};

/**
 * Resets complete form to original values (for backwards compatibility)
 */
export const resetCompleteForm = (
  form: UseFormReturn<any>, 
  businessDetails: ExtendedBusinessDetails
) => {
  form.reset(createCompleteFormDefaults(businessDetails));
};